module.exports = __webpack_public_path__ + "assets/img/assistant-ths.30a28602.png";